import { createContext } from 'react'
import FlowStep from './FlowStep'

export const PageFlowContext = createContext('')

const PageFlow = ({ children, currentStep }) => (
  <PageFlowContext value={currentStep}>{children}</PageFlowContext>
)

PageFlow.Step = FlowStep

export default PageFlow
